<template>
        <b-col>
            <img :src="companyLogo" class="company-logo">
        </b-col>
</template>

<script>
export default {
    name: "MenuLogoCompanyLogo",
    props: {
        companyLogo: String
    }
}
</script>

<style lang="scss" scoped>

    .company-logo {
        height: 40px;
    }

</style>